import { Pipe, PipeTransform } from '@angular/core';
import { CommonAddressResponse } from '../../core/models/CommonAddressResponse';

@Pipe({
    name: 'filterAddress'
})
export class FilterAddressPipe implements PipeTransform {

    transform(allPredefinedPlaces: CommonAddressResponse[], searchText: string): CommonAddressResponse[] {
        if (!searchText) {
            return allPredefinedPlaces;
        }

        return allPredefinedPlaces.filter(place =>
            place.fullAddress.toLowerCase().includes(searchText.toLowerCase())
        );
    }

}
